import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Info from "@mui/icons-material/Info";
function RenderCellDetails({ row, openDetails, setOpenDetails, }) {
    if (!row.details || Object.keys(row.details).length <= 0) {
        return _jsx(Fragment, {});
    }
    return (_jsx(Info, { color: "primary", sx: { cursor: "pointer", float: "right" }, onClick: () => setOpenDetails ? setOpenDetails(!openDetails) : undefined }));
}
export default RenderCellDetails;
//# sourceMappingURL=RenderCellDetails.js.map